import { render, staticRenderFns } from "./copayment.vue?vue&type=template&id=60a5aa14&scoped=true&"
import script from "./copayment.vue?vue&type=script&lang=js&"
export * from "./copayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5aa14",
  null
  
)

export default component.exports